import React from 'react'
import PropTypes from 'prop-types'
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { parse, format, isValid as isValidDate } from 'date-fns'
import './timePickerInput.scss'

const TimePickerInput = ({ value = '', onChange, placeholder = '', className = '', disabled = false }) => {
  const parsedValue = value ? parse(value, 'HH:mm:ss', new Date()) : null
  const dateValue = parsedValue && isValidDate(parsedValue) ? parsedValue : null

  const handleChange = (newDate) => {
    const formatted = newDate && isValidDate(newDate) ? format(newDate, 'HH:mm:ss') : ''
    onChange?.(formatted)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        value={dateValue}
        onChange={handleChange}
        ampm={false}
        disabled={disabled}
        className={`time-picker-input ${className}`.trim()}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            placeholder,
          },
        }}
      />
    </LocalizationProvider>
  )
}

TimePickerInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

export default TimePickerInput
